var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-section',{attrs:{"title":"Информация о численности обучающихся за 2024 год"}},[_c('content-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }